<template>
  <div class="static-table">
    <el-table class="table" ref="multipleTable" highlight-current-row border :data="tableQuery.data" :select="tableSelects"
      size="small" @sort-change="onSortChange" @current-change="onCurrentChange" @select="onSelect"
      @selection-change="onSelectionChange" @filter-change="permissionFilterChange" @header-dragend="onColumnResize">
      <template v-for="(col, index) in tableQuery.columns" :key="getColumnIdentity(col)" :prop="col.prop" :label="col.label">
        <el-table-column v-if="(col.type || '') === 'selection'" type="selection" :width="col.width || 55"
          align="center" />

        <el-table-column v-else-if="(col.type || '') === 'index'" :label="col.label" width="50" align="center">
          <template #default="scope">
            <span>{{ scope.$index + (tableQuery.page - 1) * tableQuery.rows + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column v-else-if="(col.type || '') === 'template'" :prop="col.prop" :label="col.label"
          :column-key="col.prop"
          :align="col.align || 'center'" :sortable="col.sortable" :width="col.width || 0"
          :fixed="col.fixed || false"
          :show-overflow-tooltip="col.showOverflowTooltip || false"
          :filters="getPermissionFilters(col)" :filter-multiple="getPermissionFilterMultiple(col)" :filter-method="getPermissionFilterMethod(col)">
          <template #default="scope">
            <slot :name="col.prop" :row="scope.row"></slot>
          </template>
        </el-table-column>
        
        <el-table-column v-else-if="(col.type || '') === 'toolbar'" :label="col.label" :width="col.width || 0"
          fixed="right" align="center">
          <template #default="scope">
            <slot name="toolbar" :row="scope.row" :id="scope.row.id"></slot>
          </template>
        </el-table-column>

        <template v-else-if="(col.type || '') === 'hidden'" :sortable="col.sortable" :width="0">
        </template>

        <el-table-column v-else="(col.type || '') === ''" :prop="col.prop" :label="col.label" :sortable="col.sortable"
          :column-key="col.prop"
          :width="col.width || 0" :align="col.align || 'left'"
          :show-overflow-tooltip="col.showOverflowTooltip || false"
          :filters="getPermissionFilters(col)" :filter-multiple="getPermissionFilterMultiple(col)" :filter-method="getPermissionFilterMethod(col)">
        </el-table-column>
      </template>
    </el-table>
    <el-pagination class="pagination" :currentPage="tableQuery.page" :page-size="tableQuery.rows || tableQuery.size || 10"
      :page-sizes="[10, 20, 50, 100, 200, 500]" layout="total, sizes, prev, pager, next, jumper"
      :total="tableQuery.records || 0" background @size-change="pageSizeHandler" @current-change="pageChangHandler" />
  </div>
</template>
<script>
export default {
  components: {},
  name: "BasicTable",
  props: {
    query: { type: Object, required: false },
    selects: { type: Object, required: false },
    // legacy props (for pages migrated from static-table)
    pager: { type: Object, required: false },
    columns: { type: Array, required: false },
    checkedRows: { type: Object, required: false },
    currHandler: { type: Function, required: false },
    seleHandler: { type: Function, required: false },
    sortHandler: { type: Function, required: false },
    pageHandler: { type: Function, required: false },
    sizeHandler: { type: Function, required: false },
    selectHandler: { type: Function, required: false },
    filterHandler: { type: Function, required: false },
  },
  emits: ["handler"],
  computed: {
    tableQuery() {
      if (this.query) return this.query;
      const legacyQuery = this.pager || {};
      if (Array.isArray(this.columns)) legacyQuery.columns = this.columns;
      if (!Array.isArray(legacyQuery.columns)) legacyQuery.columns = [];
      if (!Array.isArray(legacyQuery.data)) legacyQuery.data = [];
      if (!legacyQuery.page) legacyQuery.page = 1;
      if (!legacyQuery.rows && !legacyQuery.size) legacyQuery.rows = 10;
      if (typeof legacyQuery.records === 'undefined' || legacyQuery.records === null) legacyQuery.records = 0;
      return legacyQuery;
    },
    tableSelects() {
      return this.selects || this.checkedRows || [];
    },
  },
  data() {
      return {
        //pager: { page: 1, rows: 10, records: 0 }
        chooseRow: null,
        selectIds: [],   //当页勾选的数据
        dragSourceIndex: -1, // 当前拖拽源列索引
        isRestoringColumns: false, // 正在从缓存恢复列，避免 watch 重入
        appliedColumnsCacheKey: '', // 已应用的缓存 key，避免重复恢复
        permissionFilters: [
          { text: '明文展示', value: '0' },
          { text: '部分脱敏', value: '1' },
          { text: '全部脱敏', value: '2' },
        ],
      };
    },
  methods: {
    isDraggableColumn(col) {
      const type = (col?.type || '');
      return type !== 'hidden' && type !== 'toolbar' && !col?.fixed;
    },
    getPermissionFilters(col) {
      return Object.prototype.hasOwnProperty.call(col || {}, 'permission') ? this.permissionFilters : undefined;
    },
    getPermissionFilterMethod(col) {
      return Object.prototype.hasOwnProperty.call(col || {}, 'permission') ? this.permissionFilterMethod : null;
    },
    getPermissionFilterMultiple(col) {
      return Object.prototype.hasOwnProperty.call(col || {}, 'permission') ? false : undefined;
    },
    permissionFilterMethod() {
      return true;
    },
    getColumnIdentity(col) {
      if (col?.prop) return `prop:${col.prop}`;
      return `meta:${col?.type || ''}:${col?.label || ''}`;
    },
    getColumnsCacheKey() {
      if (!Array.isArray(this.tableQuery.columns) || this.tableQuery.columns.length === 0) return '';
      const identities = this.tableQuery.columns.map(col => this.getColumnIdentity(col)).sort();
      return `basic-table-columns:${identities.join('|')}`;
    },
    saveColumnsCache() {
      if (!Array.isArray(this.tableQuery.columns)) return;
      const key = this.getColumnsCacheKey();
      if (!key) return;
      const payload = this.tableQuery.columns.map(col => ({
        id: this.getColumnIdentity(col),
        permission: Object.prototype.hasOwnProperty.call(col || {}, 'permission') ? Number(col.permission) : undefined,
        width: Object.prototype.hasOwnProperty.call(col || {}, 'width') ? col.width : undefined,
      }));
      this.$util.setPageCache(key, payload);
    },
    ensureColumnsCacheApplied() {
      const key = this.getColumnsCacheKey();
      if (!key || this.appliedColumnsCacheKey === key) return;
      this.appliedColumnsCacheKey = key;
      this.restoreColumnsFromCache(key);
    },
    restoreColumnsFromCache(cacheKey) {
      if (this.isRestoringColumns || !Array.isArray(this.tableQuery.columns)) return;
      const key = cacheKey || this.getColumnsCacheKey();
      if (!key) return;
      const raw = this.$util.getPageCache(key);
      if (!raw) return;

      let cachedColumns = null;
      try {
        cachedColumns = JSON.parse(raw);
      } catch (error) {
        console.error('Failed to parse basic-table columns cache:', error);
        this.$util.setPageCache(key, '');
        return;
      }
      if (!Array.isArray(cachedColumns) || cachedColumns.length === 0) return;

      const source = this.tableQuery.columns.map((col, originalIndex) => ({ col, originalIndex, id: this.getColumnIdentity(col) }));
      const cachedOrderMap = new Map(cachedColumns.map((item, index) => [item.id, index]));
      const reorderedWithIndex = [...source].sort((a, b) => {
        const aOrder = cachedOrderMap.has(a.id) ? cachedOrderMap.get(a.id) : Number.MAX_SAFE_INTEGER + a.originalIndex;
        const bOrder = cachedOrderMap.has(b.id) ? cachedOrderMap.get(b.id) : Number.MAX_SAFE_INTEGER + b.originalIndex;
        return aOrder - bOrder;
      });
      const reordered = reorderedWithIndex.map(item => item.col);

      const cachedPermissionMap = new Map(cachedColumns.map(item => [item.id, item.permission]));
      const cachedWidthMap = new Map(cachedColumns.map(item => [item.id, item.width]));
      let permissionChanged = false;
      let widthChanged = false;
      reordered.forEach(col => {
        if (!Object.prototype.hasOwnProperty.call(col || {}, 'permission')) return;
        const cachedPermission = Number(cachedPermissionMap.get(this.getColumnIdentity(col)));
        if (Number.isNaN(cachedPermission) || col.permission === cachedPermission) return;
        col.permission = cachedPermission;
        permissionChanged = true;
      });
      reordered.forEach(col => {
        const cachedWidth = cachedWidthMap.get(this.getColumnIdentity(col));
        if (typeof cachedWidth === 'undefined' || cachedWidth === null || cachedWidth === '') return;
        const normalizedWidth = String(cachedWidth);
        if (String(col.width) === normalizedWidth) return;
        col.width = normalizedWidth;
        widthChanged = true;
      });

      const orderChanged = reordered.some((col, index) => col !== this.tableQuery.columns[index]);
      if (!orderChanged && !permissionChanged && !widthChanged) return;

      this.isRestoringColumns = true;
      this.tableQuery.columns.splice(0, this.tableQuery.columns.length, ...reordered);
      this.$nextTick(() => {
        this.isRestoringColumns = false;
        this.bindHeaderDrag();
      });

      if (permissionChanged) {
        this.tableQuery.page = 1;
        this.emitHandlerByMode('filter');
      }
    },
    // 仅拖拽可重排列（hidden/fixed 列不参与顺序调整）
    getDraggableColumns() {
      if (!Array.isArray(this.tableQuery.columns)) return [];
      return this.tableQuery.columns.filter(col => this.isDraggableColumn(col));
    },
    // 读取主表头单元格并排除滚动占位列（避免误取 fixed 区域表头）
    getHeaderCells(expectedCount = 0) {
      const tableEl = this.$refs.multipleTable?.$el;
      if (!tableEl) return [];
      const wrappers = Array.from(tableEl.querySelectorAll('.el-table__header-wrapper'));
      if (!wrappers.length) return [];

      let bestCells = [];
      let exactMatched = false;
      wrappers.forEach(wrapper => {
        const cells = Array.from(wrapper.querySelectorAll('thead tr th'))
          .filter(th => !th.classList.contains('gutter'));
        if (!exactMatched && expectedCount > 0 && cells.length === expectedCount) {
          bestCells = cells;
          exactMatched = true;
          return;
        }
        if (!exactMatched && cells.length > bestCells.length) bestCells = cells;
      });
      return bestCells;
    },
    // 绑定表头拖拽事件（避免重复绑定）
    bindHeaderDrag() {
      const draggableColumns = this.getDraggableColumns();
      const cells = this.getHeaderCells(draggableColumns.length);
      cells.forEach((cell, index) => {
        if (!draggableColumns[index]) return;
        cell.dataset.columnIndex = String(index);
        if (cell.dataset.dragBound === '1') return;
        cell.setAttribute('draggable', 'true');
        cell.style.cursor = 'move';
        cell.addEventListener('dragstart', this.handleHeaderDragStart);
        cell.addEventListener('dragover', this.handleHeaderDragOver);
        cell.addEventListener('drop', this.handleHeaderDrop);
        cell.addEventListener('dragend', this.handleHeaderDragEnd);
        cell.dataset.dragBound = '1';
      });
    },
    handleHeaderDragStart(event) {
      const index = Number(event.currentTarget?.dataset?.columnIndex);
      if (Number.isNaN(index)) return;
      this.dragSourceIndex = index;
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', String(index));
      }
    },
    handleHeaderDragOver(event) {
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    },
    // 拖拽落点后重排 query.columns：hidden/fixed 列保持原位，仅重排可拖拽列
    handleHeaderDrop(event) {
      event.preventDefault();
      const targetIndex = Number(event.currentTarget?.dataset?.columnIndex);
      const sourceIndex = this.dragSourceIndex;
      this.dragSourceIndex = -1;
      if (Number.isNaN(sourceIndex) || Number.isNaN(targetIndex) || sourceIndex === targetIndex) return;
      if (!Array.isArray(this.tableQuery.columns)) return;

      const source = this.tableQuery.columns;
      const draggable = source.filter(col => this.isDraggableColumn(col));
      if (sourceIndex < 0 || targetIndex < 0 || sourceIndex >= draggable.length || targetIndex >= draggable.length) return;

      const moved = draggable.splice(sourceIndex, 1)[0];
      draggable.splice(targetIndex, 0, moved);

      let draggableCursor = 0;
      const reordered = source.map(col => (this.isDraggableColumn(col) ? draggable[draggableCursor++] : col));
      this.tableQuery.columns.splice(0, this.tableQuery.columns.length, ...reordered);
      this.saveColumnsCache();
      this.$nextTick(() => this.bindHeaderDrag());
    },
    handleHeaderDragEnd() {
      this.dragSourceIndex = -1;
    },
    onColumnResize(newWidth, oldWidth, column) {
      if (!Array.isArray(this.tableQuery.columns)) return;
      const width = Math.round(Number(newWidth));
      if (!Number.isFinite(width) || width <= 0) return;

      const prop = column?.property || column?.columnKey;
      let targetColumn = null;
      if (prop) {
        targetColumn = this.tableQuery.columns.find(col => col?.prop === prop);
      } else if (column?.label) {
        targetColumn = this.tableQuery.columns.find(col => col?.label === column.label);
      }
      if (!targetColumn) return;

      const normalizedWidth = String(width);
      if (String(targetColumn.width) === normalizedWidth) return;
      targetColumn.width = normalizedWidth;
      this.saveColumnsCache();
    },
    permissionFilterChange(filters) {
      if (!Array.isArray(this.tableQuery.columns)) return;
      let changed = false;
      this.tableQuery.columns.forEach(col => {
        if (!Object.prototype.hasOwnProperty.call(col || {}, 'permission') || !col.prop) return;
        const selected = filters?.[col.prop];
        if (!Array.isArray(selected) || selected.length === 0) return;
        const permission = Number(selected[0]);
        if (Number.isNaN(permission) || col.permission === permission) return;
        col.permission = permission;
        changed = true;
      });
      if (changed) {
        this.saveColumnsCache();
        this.tableQuery.page = 1;
        this.emitHandlerByMode('filter');
      }
    },
    emitHandlerByMode(kind, payload) {
      if (this.query) {
        this.$emit('handler', this.tableQuery);
        return;
      }
      if (kind === 'sort' && typeof this.sortHandler === 'function') {
        this.sortHandler(payload);
        return;
      }
      if (kind === 'size' && typeof this.sizeHandler === 'function') {
        this.sizeHandler(payload);
        return;
      }
      if (kind === 'page' && typeof this.pageHandler === 'function') {
        this.pageHandler(payload);
        return;
      }
      if (kind === 'filter') {
        if (typeof this.filterHandler === 'function') {
          this.filterHandler(this.tableQuery, this.tableQuery.columns);
          return;
        }
        if (typeof this.pageHandler === 'function') {
          this.pageHandler(this.tableQuery.page || 1);
        }
      }
    },
    onSortChange: function (order) {
      this.tableQuery.sidx = order.prop;
      this.tableQuery.sord = order.order;
      this.emitHandlerByMode('sort', order);
    },
    pageSizeHandler: function (rows) {
      this.tableQuery.rows = rows;
      this.emitHandlerByMode('size', rows);
    },
    pageChangHandler: function (page) {
      this.tableQuery.page = page;
      this.emitHandlerByMode('page', page);
    },

    onCurrentChange: function (row) {
      //console.log('currentHandler', row);
      this.chooseRow = row;
      this.tableQuery.current = row;
      if (typeof this.currHandler === 'function') this.currHandler(row);
      //this.$emit('currentHandler', this.query);
    },
    processSelectionRows(rows) {  //勾选发生变动的时候
      //if(!this.selectIds) return;
      //console.log('selectHandler this.selectRows', this.selectRows);
      //console.log('selectHandler all rows',this.$refs.multipleTable.data);
      //console.log('selectHandler start', this.selectRows);

      //this.selectRows = rows;
      //console.log('selectHandler rows', rows)

      //先循环当前页面行数据(不管有没有选中)
      let pageRows = this.$refs.multipleTable.data;
      pageRows.forEach(item => {
        let checked = rows.indexOf(item) >= 0; //是否勾选了该行
        let existed = this.selectIds.indexOf(item.id) >= 0; //勾选总数据中是否已存在

        //console.log('selectHandler name rows',item.realName, rows);

        //如果勾选上了该行，且总勾选中不存在就添加
        if (checked && !existed) {
          this.selectIds.push(item.id);
        }

        //如果取消勾选了该行，且总勾选中存在就删除
        if (!checked && existed) {
          this.selectIds = this.selectIds.filter(q => q != item.id);
        }
      });
      //console.log('selectHandler result', this.selectIds);

      //通过当前行的数据，对比勾选上的数据，得到未勾选的数据。去更新整个数据
      //this.selectRows = rows;
      //this.query.selects = rows;
      //this.$emit('handler', this.query);
    },
    onSelect(selection, row) {
      if (typeof this.selectHandler === 'function') this.selectHandler(selection, row);
      this.processSelectionRows(selection);
    },
    onSelectionChange(rows) {
      this.processSelectionRows(rows);
      if (typeof this.seleHandler === 'function') this.seleHandler(rows);
    },
  },
  mounted() {
    this.ensureColumnsCacheApplied();
    // 首次渲染后初始化表头拖拽
    this.$nextTick(() => this.bindHeaderDrag());
  },
  watch: {
    tableQuery: {
      handler(newValue, oldValue) {
      //console.log('basic-table-watch oldValue.newValue', oldValue,newValue);
      let that = this;
      // if (newValue && newValue.selects)
      //   setTimeout(() => {
      //     newValue.selects.forEach(item => {
      //       console.log('that.$refs.multipleTable',that.$refs.multipleTable);
      //       that.$refs.multipleTable.toggleRowSelection(item);
      //     })
      //   });

      //console.log('init selects', this.selectRows)

      //如果设置了selects表示需要对checkedRows进行设置  
      //oldValue && !oldValue.selects &&
      if (this.selectIds) {
        this.selectIds.forEach(item => { // checkedData为已选数据
          this.$nextTick(() => {
            this.tableQuery.data.find(obj => { // userData 表单数据
              if (item === obj.id) {
                this.$refs.multipleTable.toggleRowSelection(obj, true)
                //console.log('toggleRowSelection', obj.realName);
              }
            })
          })
        })
      }
      if (!this.isRestoringColumns) {
        this.ensureColumnsCacheApplied();
        this.saveColumnsCache();
      }
      this.$nextTick(() => this.bindHeaderDrag());
      },
      deep: true,
    },
    tableSelects: function (newValue, oldValue) {
      //console.log('basic-table-selects oldValue.newValue.selectIds', oldValue, newValue, this.selectIds);
      this.selectIds = newValue || [];
    }
  }
};
</script>
<style scoped></style>
